import { RoutingConfiguration } from '~/features/workflow-routing/types';
import { everest } from '~/services/serviceInstances';
import { Nullable } from '~/types/Nullable';

import { ServerRoutingConfigurationResponse } from '../../types/routings/routing-configuration';

type ServerResponse = ServerRoutingConfigurationResponse;

export const getRoutingConfiguration = async (): Promise<
  Nullable<RoutingConfiguration>
> => {
  const response: ServerResponse = await everest.get('/routing-configuration');

  if (!response.data) {
    return null;
  }

  return {
    id: response.data.id,
    allUserActivationStatus: response.data.allUserActivationStatus,
    instructions: response.data.instructions,
    fallbackResponse: response.data.fallbackResponse,
    firstActivationDate: response.data.firstActivationDate,
    lastActivationDate: response.data.lastActivationDate,
    createdDate: response.data.createdDate,
    modifiedDate: response.data.modifiedDate,
    createdById: response.data.createdById,
    modifiedById: response.data.modifiedById,
    versionNumber: response.data.versionNumber,
  };
};
